/* eslint-disable unicorn/no-array-for-each */
/* eslint-disable unicorn/no-negated-condition */
/* eslint-disable unicorn/prefer-structured-clone */
import {
  GET_COLLABORATION_USERS_ROUTINE,
  GET_COLLABORATION_UNREADS_COUNT_ROUTINE,
  MARK_COLLABORATION_CHANNEL_AS_READ,
  NEW_UNREAD_NOTIFICATION_RECEIVED,
} from "constants/ActionTypes";
import { createReducer } from "@reduxjs/toolkit";
import _ from "lodash";
import { ReduxRootState } from "../../types/redux-store";

type State = ReduxRootState["entities"]["collaboration"];
const initialState = {
  collaborators: [],
  unreads: [],
} as State;

const collaborationReducer = createReducer(initialState, {
  [GET_COLLABORATION_USERS_ROUTINE.SUCCESS]: (state, action) => {
    return {
      ...state,
      collaborators: action.payload,
    };
  },
  [NEW_UNREAD_NOTIFICATION_RECEIVED.SUCCESS]: (
    state,
    action: {
      payload: { channelId: string; activeChannelIds?: string[] };
    }
  ) => {
    const { channelId, activeChannelIds = [] } = action.payload;
    if (activeChannelIds.includes(channelId)) {
      return state;
    }
    const newUnreads = state.unreads.some((u) => u.channelId === channelId)
      ? state.unreads.map((u) => {
          if (u.channelId === channelId) {
            return { ...u, unreads: u.unreads + 1 };
          }
          return u;
        })
      : [...state.unreads, { channelId, unreads: 1 }];
    return {
      ...state,
      unreads: newUnreads,
    };
  },
  [MARK_COLLABORATION_CHANNEL_AS_READ]: (state, { payload: { channelId } }) => {
    const updateUnreadsCounter = _.cloneDeep(state.unreads).map((channel) => {
      if (channel.channelId === channelId) {
        channel.unreads = 0;
      }
      return channel;
    });

    return {
      ...state,
      unreads: updateUnreadsCounter,
    };
  },
  [GET_COLLABORATION_UNREADS_COUNT_ROUTINE.SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      unreads: payload,
    };
  },
});

export default collaborationReducer;
